import axios from "axios"
import DataProvider from "./DataProvider"
import io from "socket.io-client"
import uiService from './uiService';
import LINK_USER_GUIDE from "@/constant/linkUserGuide";

declare global {
    interface Window {
        webviewEnabled: boolean
        webviewGetData: any
        webviewExecuteCommand: any
        webviewOnDataUpdated: any
    }
}


function getRequests(): any {
    const s1 = location.search.substring(1, location.search.length).split('&');
    const r = {};
    for (const s2 of s1) {
        const items = s2.split('=');
        r[decodeURIComponent(items[0]).toLowerCase()] = decodeURIComponent(items[1]);
    }
    return r;
}

function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms))
}

let inst: any;
let errorSocketTimeoutHandler: any = null;
if (window.webviewEnabled) {
    inst = new DataProvider({
        async getter(key) {
            return await window.webviewGetData(key)
        }
    })

    inst.executeCommand = window.webviewExecuteCommand

    window.webviewOnDataUpdated = (key: string, value: any) => {
        inst.refreshData(key, value)
    }
} else {
    let willContinue = true
    const data = getRequests()
    if (data.os) {
        sessionStorage.setItem("os", data.os)
    }
    const urlUserGuide = LINK_USER_GUIDE
    if (data.authorized_token) {
        sessionStorage.setItem("authenToken", data.authorized_token)
        let url = "/ui/"
        let focusContent = ''
        const urlGuides = location.search.substring(1, location.search.length).split('&')

        if (urlGuides && Array.isArray(urlGuides)) {
            focusContent = `?${urlGuides[0]}`
        }
        if (location.hash) {
            focusContent += `${location.hash}`
        }
        if (focusContent) {
            focusContent = focusContent.split('authorized_token')[0]
        }
        if (data.t) {
            url = url + "?t=" + data.t
        }
        if (!data.keep_default_url) {
            if (!urlUserGuide.includes(location.pathname)) {
                location.replace(url)
                willContinue = false
            } else {
                location.replace(location.pathname + focusContent)
                willContinue = false
            }
        }
    }
    if (willContinue) {
        const authenToken = sessionStorage.getItem("authenToken") || ""
        inst = new DataProvider({
            async getter(key: string) {
                const {data} = await axios.get("/data/" + key, {
                    params: {
                        token: authenToken,
                    }
                })
                if (data.error) {
                    await sleep(1000)
                    const {data} = await axios.get("/data/" + key, {
                        params: {
                            token: authenToken,
                        }
                    })
                    if (data.error) {
                        throw new Error(data.error + ": /data/" + key)
                    } else {
                        return data.data
                    }
                } else {
                    return data.data
                }
            }
        })

        inst.executeCommand = async (command: string, params: any) => {
            if (params === undefined) {
                params = null
            }
            const {data} = await axios.post("/execute_command/" + command, JSON.stringify(params), {
                params: {
                    token: authenToken,
                },
            })
            if (data.error) {
                throw new Error(data.error)
            } else {
                return data.data
            }
        }
        const socket = io.connect("/", {
            query: {
                token: authenToken,
            }
        })

        socket.on("error", () => {
            console.log('error socket');
            if (!errorSocketTimeoutHandler) {
                errorSocketTimeoutHandler = setTimeout(() => {
                    window.location.reload();
                }, 3000)
            }
        })

        socket.on("connect", () => {
            inst.refreshData("localAppConnected", true, true)
        })

        socket.on('disconnect', () => {
            inst.refreshData("localAppConnected", false, true);
        });

        socket.on("data-updated", (key: string, value: any) => {
            inst.refreshData(key, JSON.parse(value))
        })

        socket.on("executed", (key: string, value: any) => {
            uiService.executeCommand(key, JSON.parse(value))
        })
    }
}

export default inst
